import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LocaleService } from '../services/locale/locale.service';

@Injectable({
  providedIn: 'root',
})
export class TranslationResolver {
  constructor(
    private translate: TranslateService,
    private localeService: LocaleService
  ) {}

  async resolve(route: ActivatedRouteSnapshot): Promise<void> {
    const currentLocale =
      localStorage.getItem('locale') ?? environment.DEFAULT_LOCALE;

    // Check if translations are already loaded for the current locale
    const existingTranslations = this.translate.translations[currentLocale];

    if (
      !existingTranslations ||
      Object.keys(existingTranslations).length === 0
    ) {
      // Force load translations by calling use() which triggers the CustomLoader
      try {
        await firstValueFrom(this.translate.use(currentLocale));
        console.log(
          'Translations loaded via resolver for locale:',
          currentLocale
        );
      } catch (error) {
        console.error('Failed to load translations via resolver:', error);
      }
    } else {
      console.log('Translations already loaded for locale:', currentLocale);
    }
  }
}
